import { Type } from 'app/actions/form/types';
import { HomeEquityProgram, HomeEquityRatesResponse } from 'app/api/home-equity/types';
import { RootState } from 'app/store/types';

const initialState: HomeEquityRatesResponse = {
  fixedRatePrograms: [],
};

export const homeEquityRatesReducer = (state = initialState, action): HomeEquityRatesResponse => {
  switch (action.type) {
    case Type.AJAX_FETCH_HOME_EQUITY_RATES_SUCCESS:
      return action.payload;

    default:
      return state;
  }
};

export const homeEquityFixedRatesSelector = (state: RootState): HomeEquityProgram[] => {
  return state.homeEquityRates.fixedRatePrograms.sort((a,b) => a.termInYears > b.termInYears ? 1 : -1);
};

export const homeEquityLineOfCreditSelector = (state: RootState): HomeEquityRatesResponse['lineOfCredit'] => {
  return state.homeEquityRates.lineOfCredit;
};